import { toMinWage } from '@data/dto/min-wage.dto';
import { MinWage } from '@data/models/min-wage.interface';
import { StateCreator } from 'zustand';

export interface MinWageState {
  minWage: MinWage;
  setMinWage: (minWage: MinWage) => void;
}

export const createMinWageSlice: StateCreator<
  MinWageState,
  [['zustand/devtools', never]],
  [['zustand/persist', never]],
  MinWageState
> = (set) => ({
  minWage: toMinWage({}),
  setMinWage: (minWage: MinWage) => set(() => ({ minWage })),
});
